import React, { useEffect, useState } from "react";
import { makeStyles } from '@material-ui/core/styles';
import MyTable from '../../../../utils/MyTable';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import DefaultScrollWithHeaderContent from "../../../../utils/DefaultScrollWithHeaderContent";

import { useDispatch, useSelector } from "react-redux";

import moment from 'moment';

import XLSX from 'xlsx';
import _ from 'lodash';
import { ArrowDropDown, ArrowDropUp } from '@material-ui/icons';
import { useMemo } from "react";
import { headerSearch, unoTheme } from "../../../../../assets/styles/unoTheme";
import { loadClientRentsBySegment } from "../../../../../controllers/ClientController";
import allActions from "../../../../../actions";
import { applyMaskAmount, applyMaskAmountFreeDecimals, getShortMonthName, greenOrRed } from "../../../../utils/utils";
import { downloadBlob, s2ab } from "../../../../../controllers/ExcelController";
import { useImperativeHandle } from "react";
import { forwardRef } from "react";
import { TableFooter } from "@material-ui/core";

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column'
    },
    headerSearch: headerSearch,
    toStickyHeader: {
        display: 'flex',
        height: '100%',
    },
    tableColumn: {
        display: 'flex',
        justifyContent: "center",
        alignItems: 'center',
    },
    myTableFooter: {
        cursor: "pointer",
        borderBottom: 'unset',
        '& > *': {
            borderBottom: 'unset',
        },
        '& .totalLineInvestiments': {
            '& .MuiTableCell-root': {
                color: 'black',
                borderBottom: 'unset',
                background: unoTheme.mainGrayColor,
            },
        },
        '& .totalLinePL': {
            '& .MuiTableCell-root': {
                borderBottom: 'unset',
                color: 'white',
                background: unoTheme.mainColor,
            },
        },
        '& .MuiTableCell-root:first-child': {
            borderTopLeftRadius: '10px',
            borderBottomLeftRadius: '10px',
        },
        '& .MuiTableCell-root:last-child': {
            borderTopRightRadius: '10px',
            borderBottomRightRadius: '10px',
        },
        '& .spanTotal': {
            fontSize: '14px',
        }
    },
});

const ClassesTab = forwardRef((props, ref) => {

    const classes = useStyles();
    const dispatch = useDispatch();

    const { segmentSelected } = props;

    const clientOn = useSelector(state => state.clientOn);
    const [clientReturns, setClientReturns] = useState([]);
    const [lastQuota, setLastQuota] = useState(null);

    const [orderBy, setOrderBy] = useState("date_quota");
    const [order, setOrder] = useState("desc");

    const [innerLoad, setInnerLoad] = useState({
        emptyMessage: "",
        loadMessage: "Carregando retornos por classe...",
        size: "small"
    });

    async function doGetAllClientReturnsBySegment(clientId, month, year, segmentCod) {

        if (!segmentCod) {
            setInnerLoad({ emptyMessage: "Selecione uma classe para visualizar os retornos." });
            return;
        }

        setInnerLoad({ loadMessage: "Carregando retornos por classe...", size: "small" });

        const response = await loadClientRentsBySegment(clientId, month, year, 1);

        if (response && response.isSuccessful) {

            const diarys = response.mapDiarysBySegment[segmentCod];
            const lastQuotaSegment = response.lastQuotasBySegment[segmentCod];

            if (!diarys || diarys.length === 0) {
                setClientReturns([]);
                setLastQuota(null);
                setInnerLoad({ emptyMessage: "Nenhum retorno encontrado para esta classe no período." });
                return;
            }

            const returnsData = diarys.slice().reverse().map(item => {
                const new_pl = parseFloat(item.new_pl);
                const result_app_rescues = parseFloat(item.result_app_rescues);
                const pl_before = parseFloat(item.pl_before);
                return {
                    ...item,
                    return: new_pl - result_app_rescues - pl_before
                };
            });

            setClientReturns(returnsData);
            setLastQuota(lastQuotaSegment || null);
            setInnerLoad(null);

        } else {
            setInnerLoad({ emptyMessage: "Erro ao consultar retornos por classe." });
        }
    }

    function doExcel(items, month, year) {

        const fileName = 'Retornos_Classe_' + getShortMonthName(month) + '_' + year;

        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: true,
            loadMessage: 'Gerando planilha...',
        }));

        const wb = XLSX.utils.book_new();
        wb.Props = { Title: fileName, Author: "UNO" };

        const sheetName = fileName;
        wb.SheetNames.push(sheetName);

        const ws_data = [];
        ws_data.push([
            'Data',
            'PL (início do dia)',
            'Movimentações',
            'Retorno (R$)',
            'Cota',
            'Retorno (%)',
            'PL (fim do dia)',
        ]);

        items.forEach(row => {
            ws_data.push([
                moment.utc(row.date_quota).format('DD/MM/YYYY'),
                applyMaskAmount(row.pl_before, true),
                applyMaskAmount(row.result_app_rescues, true),
                applyMaskAmount(row.new_pl - parseFloat(row.result_app_rescues) - row.pl_before, true),
                applyMaskAmountFreeDecimals(row.quota_value, null, 10),
                applyMaskAmountFreeDecimals(row.rent_day) + "%",
                applyMaskAmount(row.new_pl, true),
            ]);
        });

        const ws = XLSX.utils.aoa_to_sheet(ws_data);
        wb.Sheets[sheetName] = ws;
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

        downloadBlob(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName + '.xlsx');

        dispatch(allActions.innerLoadActions.setInnerLoad({ show: false }));
    }

    const sortedReturns = useMemo(() => {
        if (!clientReturns) return [];
        if (!orderBy) return clientReturns;
        return _.orderBy(clientReturns, [orderBy], [order]);
    }, [clientReturns, orderBy, order]);

    const SortIcon = ({ column }) => {
        const isActive = orderBy === column;
        if (!isActive) return <ArrowDropDown style={{ color: "#ccc" }} />;
        return order === "asc"
            ? <ArrowDropUp style={{ color: unoTheme.mainColor }} />
            : <ArrowDropDown style={{ color: unoTheme.mainColor }} />;
    };

    const handleSort = (column) => {
        if (orderBy === column) {
            setOrder(order === "asc" ? "desc" : "asc");
        } else {
            setOrderBy(column);
            setOrder("asc");
        }
    };

    useImperativeHandle(ref, () => ({
        doExcelReport() {
            doExcel(clientReturns, clientOn.client.selectedPortfolioMonth, clientOn.client.selectedPortfolioYear);
        },
        doPdfReport() {
            // PDF não implementado para Por Classe
        }
    }));

    useEffect(() => {
        if (clientOn && clientOn.client && clientOn.client.id
            && clientOn.client.selectedPortfolioMonth && clientOn.client.selectedPortfolioYear && segmentSelected) {

            setClientReturns([]);
            setLastQuota(null);
            doGetAllClientReturnsBySegment(
                clientOn.client.id,
                clientOn.client.selectedPortfolioMonth,
                clientOn.client.selectedPortfolioYear,
                segmentSelected
            );

        } else {
            setInnerLoad({
                emptyMessage: "Os retornos se dão a partir do lançamento de pelo menos um mês de carteira",
            });
        }

    }, [clientOn, segmentSelected]);

    return (
        <div className={classes.root}>
            <DefaultScrollWithHeaderContent innerLoad={innerLoad}>
                <MyTable stickyHeader size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell onClick={() => handleSort("date_quota")}>
                                <div className={classes.tableColumn}>
                                    Data <SortIcon column="date_quota" />
                                </div>
                            </TableCell>
                            <TableCell onClick={() => handleSort("pl_before")}>
                                <div className={classes.tableColumn}>
                                    PL <span style={{ color: unoTheme.mainColor, fontSize: '10px' }}>(Início do dia)</span> <SortIcon column="pl_before" />
                                </div>
                            </TableCell>
                            <TableCell onClick={() => handleSort("result_app_rescues")}>
                                <div className={classes.tableColumn}>
                                    Movimentações <SortIcon column="result_app_rescues" />
                                </div>
                            </TableCell>
                            <TableCell onClick={() => handleSort("return")}>
                                <div className={classes.tableColumn}>
                                    Retorno(R$) <SortIcon column="return" />
                                </div>
                            </TableCell>
                            <TableCell align="center">
                                Cota
                            </TableCell>
                            <TableCell onClick={() => handleSort("rent_day")}>
                                <div className={classes.tableColumn}>
                                    Retorno(%) <SortIcon column="rent_day" />
                                </div>
                            </TableCell>
                            <TableCell onClick={() => handleSort("new_pl")}>
                                <div className={classes.tableColumn}>
                                    PL <span style={{ color: unoTheme.mainColor, fontSize: '10px' }}>(Fim do dia)</span> <SortIcon column="new_pl" />
                                </div>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {sortedReturns.map((row, index) => (
                            <TableRow key={'classes-' + index}>
                                <TableCell align="center">{moment.utc(row.date_quota).format('DD/MM/YYYY')}</TableCell>
                                <TableCell align="center" style={{ color: unoTheme.mainColor }}>{applyMaskAmount(row.pl_before, true)}</TableCell>
                                <TableCell align="center" style={{ color: parseFloat(row.result_app_rescues) >= 0 ? unoTheme.greenMoney : unoTheme.redMoney }}>{applyMaskAmount(row.result_app_rescues, true)}</TableCell>
                                <TableCell align="center" style={{ color: greenOrRed(row.return) }}>{applyMaskAmount(row.return, true)}</TableCell>
                                <TableCell align="center">{applyMaskAmountFreeDecimals(row.quota_value)}</TableCell>
                                <TableCell align="center" style={{ color: greenOrRed(row.rent_day) }}>{applyMaskAmountFreeDecimals(row.rent_day)}%</TableCell>
                                <TableCell align="center" style={{ color: unoTheme.mainColor }}>{applyMaskAmount(row.new_pl, true)}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>

                    {
                        lastQuota && lastQuota.quota_value ?
                            <TableFooter className={classes.myTableFooter}>
                                <TableRow className='totalLineInvestiments' key={'footer-classes'}>
                                    <TableCell align="center">{lastQuota.date_quota ? moment.utc(lastQuota.date_quota).format('DD/MM/YYYY') : "-"}</TableCell>
                                    <TableCell align="center" style={{ color: unoTheme.mainColor }}>{"-"}</TableCell>
                                    <TableCell align="center">{"-"}</TableCell>
                                    <TableCell align="center">{"-"}</TableCell>
                                    <TableCell align="center">{applyMaskAmountFreeDecimals(lastQuota.quota_value)}</TableCell>
                                    <TableCell align="center">{"-"}</TableCell>
                                    <TableCell align="center" style={{ color: unoTheme.mainColor }}>{lastQuota.new_pl ? applyMaskAmount(lastQuota.new_pl, true) : "-"}</TableCell>
                                </TableRow>
                            </TableFooter>
                            : null
                    }

                </MyTable>
            </DefaultScrollWithHeaderContent>
        </div>
    );
});

export default ClassesTab;
